<script>
  import axios from 'axios'
  import User from 'src/models/User'
  import ApiLocalStorage from 'src/helpers/ApiLocalStorage'
  //  import routes from 'vue-router'

  export default {
    props: {
      labels: {
        type: Object,
        default () {
          return {
            title: 'Login',
            user: 'User',
            password: 'Password',
            button: 'Login'
          }
        }
      },
      apiUrl: {
        type: String,
        required: true
      },

      loginRoute: {
        type: String,
        default: 'oauth/token'
      },
      userRoute: {
        type: String,
        default: 'api/users/show-all'
      },
      clientId: {
        type: [Number, String],
        default: 2
      },
      secret: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        login: {
          user: '',
          password: ''
        },
        validationError: '',
        dialogVisible: true,
        buttonLoading: false
      }
    },
    computed: {
      loginUrl () {
        return `${this.apiUrl}/${this.loginRoute}`
      },
      userUrl () {
        return `${this.apiUrl}/${this.userRoute}`
      }
    },
    methods: {
      getHeaders (token) {
        return {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      },
      loginClick () {
        this.buttonLoading = true
        this.validationError = ''
      },
      handleLogin () {
        const postData = {
          grant_type: 'password',
          client_id: this.clientId,
          client_secret: this.secret,
          username: this.login.user,
          password: this.login.password,
          scope: ''
        }

        const authUser = {}

        axios.post(this.loginUrl, postData)
          .then(response => {
            authUser.access_token = response.data.access_token
            authUser.refresh_token = response.data.refresh_token
            let user = new User(authUser)
            user.getAccessToken()
            ApiLocalStorage.requestUserData('userDataOptions', this.userUrl).then(() => {
              this.$router.push({name: 'Dashboard'})
            })
          }).catch(error => {
            this.validationError = error.response.data.message
            this.buttonLoading = false
          })
      }
    }
  }
</script>

<template>
    <section class="hero is-fullheight is-dark is-bold">

        <el-dialog :visible.sync="dialogVisible" size="tiny" :close-on-click-modal="false"
                   :close-on-press-escape="false" :show-close="false">

            <div class="text-center">
                <img src="/static/img/logo.png">
                <p>Pit Format Statistics</p>
                <form @submit.prevent="handleLogin" class="loginInputMargin">
                    <p class="control">
                        <el-input placeholder="Login" v-model="login.user"></el-input>
                    </p>
                    <p class="control">
                        <el-input type="password" placeholder="Hasło" v-model="login.password"></el-input>
                    </p>
                    <p class="label-error" v-text="validationError"></p>
                    <hr>
                    <p class="control text-right">
                        <el-button native-type="submit" :loading="buttonLoading" @click="loginClick">Zaloguj
                        </el-button>
                    </p>
                </form>

            </div>
        </el-dialog>
    </section>
</template>

<style>
    .loginInputMargin {
        margin-top: 50px;
    }

</style>



// WEBPACK FOOTER //
// Login.vue?735291e3